export const SCORES = {
  topPriorities: {
    livingComfortably: 25,
    growth: 55,
    legacy: 75
  },
  investorProfile: {
    veryConservative: 10,
    conservative: 30,
    moderate: 50,
    aggressive: 70,
    veryAggressive: 90,
    iDontKnow: 50
  },
  financialFamiliarity: {
    stocks: 0,
    bonds: 0,
    checking: 0,
    lifeInsurance: 0,
    annuities: 0,
    pensions: 0,
    tsp: 0,
    cd: 0
  },
  coinFlip: {
    '200100': {
      "yes": 90,
      "no": 15
    },
    '300100': {
      "yes": 30,
      "no": 5
    },
    '20001000': {
      "yes": 90,
      "no": 25
    },
    '30001000': {
      "yes": 30,
      "no": 5
    }
  },
  hypotheticalInvestment: {
    buyMore: 75,
    holdAndStayTheCourse: 50,
    sellHalf: 35,
    sellEverything: 10
  }
}

export const WEIGHTS = {
  topPriorities: 10,
  investorProfile: 0,
  financialFamiliarity: 0,
  coinFlip: {
    '200100': 15,
    '300100': 10,
    '20001000': 15,
    '30001000': 10
  },
  hypotheticalInvestment: 30
}